var _linearGradient, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "Ui-root css-1pmrrd7",
    fill: "none",
    height: 16,
    viewBox: "0 0 25 24",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: ":r12:-gradient",
    gradientUnits: "userSpaceOnUse",
    x1: 3.71436,
    x2: 21.6246,
    y1: 4.5158,
    y2: 20.7203
  }, /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.473958,
    stopColor: "#ffdb00"
  }), /*#__PURE__*/React.createElement("stop", {
    className: "Ui-topHalf",
    offset: 0.474058,
    stopColor: "#ffdb00",
    stopOpacity: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    className: "Ui-bottomHalf",
    d: "m11.8572 5.57143c-3.077 0-5.57142 2.49441-5.57142 5.57147 0 3.077 2.49442 5.5714 5.57142 5.5714 1.4909 0 2.845-.5856 3.8448-1.5393.0277-.0339.0573-.0668.0889-.0984.0317-.0317.0645-.0613.0985-.0889.9537-.9999 1.5392-2.354 1.5392-3.8448 0-3.07706-2.4944-5.57147-5.5714-5.57147zm6.5952 10.34837c.9736-1.3418 1.5477-2.9923 1.5477-4.7769 0-4.49722-3.6457-8.1429-8.1429-8.1429-4.49716 0-8.14284 3.64568-8.14284 8.1429 0 4.4971 3.64568 8.1428 8.14284 8.1428 1.7846 0 3.4351-.5741 4.7769-1.5476l2.8854 2.8853c.5021.5021 1.3162.5021 1.8183 0s.5021-1.3161 0-1.8183z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.8572 5.57143c-3.077 0-5.57142 2.49441-5.57142 5.57147 0 3.077 2.49442 5.5714 5.57142 5.5714 1.4909 0 2.845-.5856 3.8448-1.5393.0277-.0339.0573-.0668.0889-.0984.0317-.0317.0645-.0613.0985-.0889.9537-.9999 1.5392-2.354 1.5392-3.8448 0-3.07706-2.4944-5.57147-5.5714-5.57147zm6.5952 10.34837c.9736-1.3418 1.5477-2.9923 1.5477-4.7769 0-4.49722-3.6457-8.1429-8.1429-8.1429-4.49716 0-8.14284 3.64568-8.14284 8.1429 0 4.4971 3.64568 8.1428 8.14284 8.1428 1.7846 0 3.4351-.5741 4.7769-1.5476l2.8854 2.8853c.5021.5021 1.3162.5021 1.8183 0s.5021-1.3161 0-1.8183z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.cfbcf114f09c5154d8ce3ade6b240f84.svg";
export { ForwardRef as ReactComponent };